export class Unauthorized extends Error
{
    type = "UnauthorizedException";
}
